import React, { memo } from 'react';
import cn from 'classnames';

import Icon from '@/components/UI/Icon';

interface InputBoolProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  error?: string;
  id?: string;
  label?: React.ReactNode;
}

const InputBool = ({
  className,
  error,
  id,
  label,
  ...props
}: InputBoolProps) => (
  <label
    className={cn('form-checkbox', { error }, className)}
    htmlFor={id}
  >
    <input
      className="form-checkbox-input"
      id={id}
      type="checkbox"
      {...props}
    />

    <span className="form-checkbox-check">
      <Icon name="Check" />
    </span>

    <span className="form-checkbox-label">
      {label}
    </span>
  </label>
);

export default memo(InputBool);
